import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import LandingPage from '../../formNodes/LandingPageNodeForm';
// import ServiceSelectionNode from '../../formNodes/ServiceSelectionNode';
// import AddressNode from '../../formNodes/AddressNodeForm';
// import AddOnsNode from '../../formNodes/AddOnsNodeForm';
// import SetupYourAccountNode from '../../formNodes/SetupYourAccount';
// import OrderReceiptNode from '../../formNodes/OrderReceiptNode';
// import ServiceNode from '../../formNodes/ServiceNode';
// import PaymentNode from '../../formNodes/PaymentNode';
// import ScheduleInstallation from '../../formNodes/SelfSchedulingNode';
// import ReviewCartNode from '../../formNodes/ReviewCartNode';
import GardenWallNode from '../../formNodes/GardenWallNode';
import SiteNode from '../../formNodes/SiteNode';
import RackNode from '../../formNodes/RackNode';
import DeviceNode from '../../formNodes/DeviceNode';
import CircuitNode from '../../formNodes/CircuitNode';
import { base64Encode } from '../../../utils/base64Utils';
import { ServiceSelectionNode } from '../../CustomNodes';
import { CLIENT_NAME } from '../../../constants/companyConfig';
import {
  AddressNode,
  ServiceNode,
  AddOnsNode,
  SelfSchedulingNode,
  PaymentNode,
  SetupAccountNode,
  CheckOutNode,
  OrderConfirmationNode,
} from '../../CustomNodes';

export const fetchWorkflows = async (token, setWorkflows) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/workflows/list`,
      { deleted_at: 'null', workflow_client: CLIENT_NAME },
      {
        headers: { Authorization: `${token}` },
      }
    );
    if (response.status === 200) {
      setWorkflows(response.data);
    }
  } catch (error) {
    console.error('Error fetching workflows:', error);
  }
};

export const saveWorkflow = async (template_id, endpoint, token, payload) => {
  try {
    const response = await axios({
      method: template_id ? 'PUT' : 'POST',
      url: `${process.env.REACT_APP_BASE_URL}/portalbuilder/${endpoint}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`,
      },
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error saveWorkflow:', error);
  }
};

export const applyChanges = async (htmlContent, prompt, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/portalbuilder/generate/template`,
      {
        template: base64Encode(htmlContent),
        userPrompt: prompt,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error('Error applyChanges:', error);
    throw error; // Optional: rethrow the error if needed
  }
};

export const extractHtmlContent = (response) => {
  const modifiedHtml = response.response;
  return modifiedHtml.includes('<!DOCTYPE html')
    ? modifiedHtml.match(/<!DOCTYPE html[^>]*>[\s\S]*<\/html>/)?.[0]?.trim() ||
        ''
    : modifiedHtml;
};

export const getDefaultContentByNodeType = (nodeType) => {
  switch (nodeType) {
    case 'landingPageNode':
      return <LandingPage />;
    case 'chooseProductsNode':
      return <ServiceNode />;
    case 'serviceSelectionNode':
      return <ServiceSelectionNode />;
    case 'addOnsNode':
      return <AddOnsNode />;
    case 'checkForServiceNode':
      return <AddressNode />;
    case 'accountSetupNode':
      return <SetupAccountNode />;
    case 'orderReceiptNode':
      return <OrderConfirmationNode />;
    case 'paymentNode':
      return <PaymentNode />;
    case 'selfSchedulingNode':
      return <SelfSchedulingNode />;
    case 'reviewCartNode':
      return <CheckOutNode />;
    case 'gardenwallNode':
      return <GardenWallNode />;
    case 'siteNode':
      return <SiteNode />;
    case 'rackNode':
      return <RackNode />;
    case 'deviceNode':
      return <DeviceNode />;
    case 'circuitNode':
      return <CircuitNode />;
    default:
      return '';
  }
};

export const getNodeType = (nodeType) => {
  switch (nodeType) {
    case 'landingPageNode':
      return 'Landing Page';
    case 'chooseProductsNode':
      return 'Choose Product';
    case 'serviceSelectionNode':
      return 'Service Selection';
    case 'addOnsNode':
      return 'AddOns';
    case 'checkForServiceNode':
      return 'Check for Service';
    case 'accountSetupNode':
      return 'Account SetUp';
    case 'orderReceiptNode':
      return 'OrderReceipt';
    case 'paymentNode':
      return 'Payment';
    case 'selfSchedulingNode':
      return 'Self Scheduling';
    case 'reviewCartNode':
      return 'ReviewCart';
    case 'gardenwallNode':
      return 'Garndenwall';
    case 'siteNode':
      return 'Site';
    case 'rackNode':
      return 'Rack';
    case 'deviceNode':
      return 'Device';
    case 'circuitNode':
      return 'Circuit';
    default:
      return '';
  }
};

export const deleteTemplate = async (templateId, token) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/portalbuilder/delete/${templateId}`,
      {
        headers: { Authorization: `${token}` },
      }
    );
    return true;
  } catch (error) {
    console.error('Error deleting template:', error);
    return false;
  }
};

export const updateTemplate = async (templateId, templateData, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BASE_URL}/portalbuilder/update/${templateId}`,
      templateData,
      {
        headers: { Authorization: `${token}` },
      }
    );
    return true;
  } catch (error) {
    console.error('Error updating template:', error);
    return false;
  }
};
